import { render, staticRenderFns } from "./AbandonedOrdersSearch.vue?vue&type=template&id=54fd71b8&"
import script from "./AbandonedOrdersSearch.vue?vue&type=script&lang=js&"
export * from "./AbandonedOrdersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports